export default __webpack_public_path__ + "static/media/blush-clear-summer.96bca49b.png";